import settings from '@/constants/constants';
import { DELIVERY_OPTION, DELIVERY_OPTIONS } from '@montugroup/circuit-shared';

const SAME_DAY_ARTICLE_URL = `${settings.support.site.url}/articles/14109778742543-Receiving-your-Afternoon-or-Evening-delivery`;

export const DELIVERY_OPTION_KNOWLEDGE_BASE_URLS: Partial<
  Record<(typeof DELIVERY_OPTIONS)[DELIVERY_OPTION]['name'], string>
> = {
  [DELIVERY_OPTIONS[DELIVERY_OPTION.SameDay].name]: SAME_DAY_ARTICLE_URL,
  [DELIVERY_OPTIONS[DELIVERY_OPTION.SameDayAfternoon].name]: SAME_DAY_ARTICLE_URL,
};
